/* eslint-disable react/no-children-prop */
import { Grid } from '@material-ui/core';
import { Text } from 'components/styleguide';
import { Trans } from 'react-i18next';
import { useRootTranslation } from 'utils/hooks';

const rootT = 'drawers.importTracksSpreadsheetDrawer.readyImport';

const ReadyToImport = () => {
  const t = useRootTranslation(rootT);

  return (
    <Grid
      container
      xs={12}
      direction="column"
      justifyContent="center"
      alignContent="center"
      alignItems="center"
    >
      <Grid item>
        <Text color="green" variant="formLabel" children={t('ready')} bold />
      </Grid>
      <Grid item>
        <Trans
          i18nKey={`${rootT}.clickToBegin`}
        >
          <Text variant="formLabel" />
          <Text variant="formLabel" bold />
        </Trans>
      </Grid>
      <Grid item>
        <Text variant="formLabel" children={t('theProcess')} />
      </Grid>
    </Grid>
  );
};

export default ReadyToImport;
